import ContentLoader from 'react-content-loader';

import { DEFAULT_SETTINGS } from '@web/consts/skeletonSettings';

const SIZES = [160, 140];
const VARIANTS = SIZES.length;
const PER_ROW = 3;

type TagSkeletonProps = {
  idx: number;
  width: number;
};
const TagSkeleton = ({ idx, width }: TagSkeletonProps) => (
  <ContentLoader
    width={width}
    height="28"
    title="Loading announcement recipient"
    uniqueKey={`announcement-recipient-${idx}-skeleton-date`}
    viewBox={`0 0 ${width} 28`}
    {...DEFAULT_SETTINGS}>
    <rect x="0" y="4" width={width} height="20" rx="3" ry="3" />
  </ContentLoader>
);

type Props = {
  counter: number;
};
/*
Layout - odd rows - 160; even - 140
160 160 160
140 140 140
160 160 160
...
*/
export const RecipientsSkeleton = ({ counter: length }: Props) => (
  <>
    {Array.from({ length }).map((_, index) => (
      <TagSkeleton
        key={`announcement-recipient-${index}-skeleton-date`}
        idx={index}
        width={SIZES[Math.floor((index % (VARIANTS * PER_ROW)) / PER_ROW)]}
      />
    ))}
  </>
);
